import PaymentType from './PaymentType';
import SavedCreditCards from './SavedCreditCards';
import NewCreditCards from './NewCreditCards';
import OrderSummary from './OrderSummary';
import { CustomImage, Text, useText } from '@src/components';
import { Form, Tooltip } from 'antd';
import masterCardLogo from '@src/assets/images/cardOrders/mastercard-logo.svg';
import logoMobilExpress from '@src/assets/images/cardOrders/logo-mobilexpress.webp';
import logoAmex from '@src/assets/images/cardOrders/american-express-logo.png';
import logoVisa from '@src/assets/images/cardOrders/visa-inc-logo.svg';
import { useDispatch, useSelector } from 'react-redux';
import '@src/styles/cardOrder/payment-type.scss';
import { useCallback, useEffect, useMemo, useReducer, useState } from 'react';
import { getCardWithVouList } from '@src/store/slice/mobilExpressSlice';
import EftWireTransferCards from '../../balanceUpload/payment/EftWireTransferCards';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { bankCodeIcon } from '@src/utils/utils';
import po from '@src/assets/icons/ticketcar/4.svg';
import ticketrestaurant from '@src/assets/images/login/logo-ticketrestaurant.svg';
import trash from '@src/assets/icons/trash.svg';
import cardSlash from '@src/assets/icons/icon-card-slash.svg';
import { useHistory } from 'react-router-dom';
import { confirmDialog } from '@src/components/CustomDialog';
import { cardOrdersDelete } from '@src/store/slice/cardOrderSlice';
import { VouIdCode } from '@src/store/enums';

const initialState = {
  savedCreditCards: false,
  newCreditCards: false,
};

function formVisibleReducer(state, action) {
  switch (action.type) {
    case 'savedCreditCards':
      return {
        savedCreditCards: true,
        newCreditCards: false,
      };
    case 'newCardAddFrom':
      return {
        savedCreditCards: false,
        newCreditCards: true,
      };
    default:
      return initialState;
  }
}

const Payment = () => {
  const dispatch = useDispatch();
  const { paymentType } = useSelector((state) => state?.mobilExpress);
  const [form] = Form.useForm();
  const [counter, setCounter] = useState(0);
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });
  const [favoriteCard, setFavoriteCard] = useState([]);
  const history = useHistory();
  const [isExitPayment, setIsExitPayment] = useState(false);

  const warningHtmlContent = <Text t="youAreLeavingThePageTheOrderInformation" />;
  const giveUpText = useText('giveUp');
  const cardText = useText('card');

  const vouId = useMemo(() => {
    if (currentCardOrder?.vouId === VouIdCode.Market) return VouIdCode.Market;
    if (currentCardOrder?.vouId === VouIdCode.Compliments) return VouIdCode.Compliments;
    return VouIdCode.Restaurant;
  }, [currentCardOrder]);
  useEffect(() => {
    const historyBlock = history.block((location) => {
      if (isExitPayment) {
        return true;
      }
      if (currentCardOrder?.id && currentCardOrder?.vouId === 94) {
        confirmDialog({
          title: <Text t="attention" />,
          htmlContent: warningHtmlContent,
          okText: <Text t="yes" />,
          cancelText: <Text t={giveUpText} />,
          closeIcon: false,
          onCancel: async (e) => {
            setIsExitPayment(false);
            return false;
          },
          onOk: async () => {
            setIsExitPayment(true);
            await dispatch(cardOrdersDelete());
            history.push(location.pathname);
          },
        });
      } else {
        return true;
      }

      return false;
    });

    return historyBlock;
  }, [history, isExitPayment, dispatch, currentCardOrder]);

  const hasActiveFlag = useCallback((array) => {
    setFavoriteCard(
      favoriteCardGroupData(array?.filter((a) => a.unlimited_Contract && a.default_Flag)),
    );
  }, []);

  const favoriteCardGroupData = (data) => {
    const groupedData = groupData(data);

    const result = Object.keys(groupedData).map((maskedCardNumber) => ({
      maskedCardNumber,
      ...groupedData[maskedCardNumber],
    }));

    return result;
  };

  const groupData = (data) => {
    if (!data || data.length === 0) {
      return {};
    }

    return data.reduce((acc, entry) => {
      const { maskedCardNumber, vouId, ...rest } = entry;

      if (!acc[maskedCardNumber]) {
        acc[maskedCardNumber] = { ...rest, vouIds: [] };
      }

      acc[maskedCardNumber].vouIds.push(vouId);

      return acc;
    }, {});
  };

  const [formVisible, visibleDispatch] = useReducer(formVisibleReducer, initialState, (state) => {
    return {
      savedCreditCards: false,
      newCreditCards: false,
    };
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      if (paymentType === 1) {
        const action = await dispatch(
          getCardWithVouList({
            VouId: vouId,
          }),
        );
        if (getCardWithVouList.fulfilled.match(action)) {
          const array = action.payload.data.cardList;
          if (array.length === 0) {
            visibleDispatch({ type: 'newCardAddFrom' });
          } else {
            visibleDispatch({ type: 'savedCreditCards' });
            hasActiveFlag(array);
          }
        } else {
          visibleDispatch({ type: 'newCardAddFrom' });
        }
      } else if (paymentType === 2) {
        visibleDispatch({ type: 'savedCreditCards' });
      }
    })();
  }, [dispatch, paymentType]);

  return (
    <div className="payment-order-content">
      <div className="payment-content">
        <div className="payment-type-content">
          <PaymentType />
          {paymentType === 1 ? (
            <>
              {favoriteCard.map((fCard, index) => {
                const bankIcon = bankCodeIcon(fCard?.bankCode);
                return (
                  <div key={fCard.maskedCardNumber + index} className="favorite-credit-card">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div className="credit-card-item">
                        <CustomImage className="bank-card-logo" src={bankIcon} />
                        <div className="card-number">{fCard.maskedCardNumber}</div>
                        <div className="card-info">
                          <CustomImage className="card-type-logo" src={masterCardLogo} />
                        </div>
                      </div>
                      <div className="credit-card-left-border">
                        <Tooltip title="Otomatik Ödemeden Çıkar" placement="top">
                          <button>
                            <CustomImage src={cardSlash} />
                          </button>
                        </Tooltip>
                        <Tooltip title="Sil" placement="top">
                          <button>
                            <CustomImage style={{ width: '16px', height: '16px' }} src={trash} />
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        marginTop: '16px',
                        gap: '8px',
                        height: '24px',
                      }}
                    >
                      {fCard?.vouIds?.includes(1) && <CustomImage src={ticketrestaurant} />}
                      {fCard?.vouIds?.includes(4) && <CustomImage src={po} />}
                    </div>
                  </div>
                );
              })}
              {formVisible?.savedCreditCards && paymentType && (
                <SavedCreditCards
                  counter={counter}
                  setCounter={setCounter}
                  handleAnotherCreditCard={() => visibleDispatch({ type: 'newCardAddFrom' })}
                />
              )}
              {formVisible?.newCreditCards && (
                <NewCreditCards
                  form={form}
                  formVisible={formVisible}
                  counter={counter}
                  setCounter={setCounter}
                  handleRegisteredCreditCard={() => visibleDispatch({ type: 'savedCreditCards' })}
                />
              )}
            </>
          ) : (
            <EftWireTransferCards type={cardText} />
          )}

          {currentCardOrder?.paymentType !== 5 && !isMobil && (
            <>
              <hr />
              <div className="footer-logo">
                <div className="left-logos">
                  <CustomImage className="logoMobil" src={logoMobilExpress} />
                  <span className={'left-logos-text'}>
                    <Text t="yourCardsAreStoredSecurelyInThePci" />
                  </span>
                </div>
                <div className="right-logos">
                  <CustomImage src={logoAmex} style={{ width: '50px', height: '50px' }} />
                  <CustomImage src={logoVisa} />
                  <CustomImage src={masterCardLogo} />
                </div>
              </div>
            </>
          )}
        </div>

        <OrderSummary
          counter={counter}
          setCounter={setCounter}
          form={form}
          formVisible={formVisible?.newCreditCards}
        />
      </div>
    </div>
  );
};

export default Payment;
